import BaseComponent from "../../../baseComponent.js";
import styles from "./licenses.scss";

class License extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      description: props.license.description,
      dataAccessAge: props.license.dataAccessAge,
      cost: props.license.cost,
      persistenceId: props.license.persistenceId
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      description: nextProps.license.description,
      dataAccessAge: nextProps.license.dataAccessAge,
      cost: nextProps.license.cost,
      persistenceId: nextProps.license.persistenceId
    });
  }

  removeLicense() {
    this.props.onRemoveBtnClicked(this.state.persistenceId);
  }

  handleChange(event, propertyName) {
    let newState = this.state;
    newState[propertyName] = event.target.value;
    this.setState(newState);
    this.props.onChanged(newState);
  }

  render() {
    let button;

    if (this.props.isLastItem) {
      button = <i className="material-icons" onClick={e => this.props.onAddBtnClicked(e)}>add_circle_outline</i>;
    } else {
      button =
        <i className="material-icons field-remove-btn" onClick={e => this.removeLicense()}>remove_circle_outline</i>;
    }

    return (
      <li className={["collection-item license", styles.container].join(" ")}>
        <div className={styles.description}>
          <input type="text" placeholder="Enter description" value={this.state.description}
                 onChange={e => this.handleChange(e, "description")}/>
        </div>
        <div className={styles.age}>
          <input type="text" placeholder="Enter aceess age" value={this.state.dataAccessAge}
                 onChange={e => this.handleChange(e, "dataAccessAge")}/>
        </div>
        <div className={styles.cost}>
          <input type="text" placeholder="Enter cost" value={this.state.cost}
                 onChange={e => this.handleChange(e, "cost")}/>
        </div>
        <div className="action-btn">
          {button}
        </div>
      </li>
    )
  }
}

export default class Licenses extends BaseComponent {
  render() {
    let licenses = this.props.licenses.map((license, index) => {
      return <License key={index}
               license={license}
               onRemoveBtnClicked={e => this.props.onRemoveBtnClicked(e)}
               onChanged={e => this.props.onLicenseChanged(e)}
               onAddBtnClicked={e => this.props.onAddBtnClicked(e)}
               isLastItem={index === this.props.licenses.length - 1}/>
    });

    return (
      <ul className="collection">
        <li className={["collection-item collection-item__header license", styles.container].join(" ")}>
          <div className={styles.description}>Description</div>
          <div className={styles.age}>Time Delay(s)</div>
          <div className={styles.cost}>Monthly Subscription Fee</div>
          <div style={{ width: "30px" }}></div>
        </li>
        {licenses}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/create/dataset/licenses.jsx